import {Component, Input} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgClass, NgForOf} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {BacklogService} from "../../../../core/services/backlog.service";
import {GeneralService} from "../../../../core/services/general.service";
import {TableService} from "../../../../core/services/table.service";

@Component({
  selector: 'app-assign-transfer-driver',
  standalone: true,
    imports: [
        FormsModule,
        NgForOf,
        ReactiveFormsModule,
        NgClass
    ],
  templateUrl: './assign-transfer-driver.component.html',
  styleUrl: './assign-transfer-driver.component.scss'
})
export class AssignTransferDriverComponent {
    @Input() confirmAction!: () => void;
    @Input() data: any;
    public validate: boolean = false;
    public transferDriverForm : FormGroup;
    public employeesLis : any = [];

    constructor(public modal:NgbModal,private fb:FormBuilder, public backlogService: BacklogService,
                private generalService: GeneralService,private tableService: TableService) {
        this.transferDriverForm = this.fb.group ({
            service_id: new FormControl(0),
            employee_id: new FormControl("", Validators.required),
        });
    }

    ngOnInit(){
        this.getEmployees();
    }

    getEmployees(){
        const data = {id:0};
        this.backlogService.getEmployee(data).subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                } else {
                    this.employeesLis = res.data;
                }
            },
            (err) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
            }
        );
    }

    assigntransferdriver(){
        if (this.transferDriverForm.invalid) {
            this.validate = true;
        } else {
            this.transferDriverForm.get('service_id')?.setValue(this.data.idService);
            this.backlogService.actionBacklog(this.transferDriverForm.value,'assigntransferdriver').subscribe(
                (res: any) => {
                    if (res.error) {
                        this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    } else {
                        this.transferDriverForm.reset();
                        this.generalService.showMessage('success', res.message);
                        this.confirmAction();
                    }
                },
                (err) => {
                    this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                }
            );
        }
    }

    /**
     * VALIDACIONES INPUTS
     */
    get employee() {
        return this.transferDriverForm.get("employee_id");
    }
}
